import { MfsStatusCode } from '@metaos/mfs-telemetry';
import { MfsFolderError } from './mfsFolderError';
/**
 * Request entity is larger than limits defined by server.
 * The server might close the connection or return an Retry-After header field.
 * HTTP Response Status Code 413
 *
 * @param message The message that will be returned to the user
 * @param eventName Identification of the event that triggered the error
 */
export class PayloadTooLarge extends MfsFolderError {
    constructor(message, eventName) {
        super(message !== null && message !== void 0 ? message : `Payload Too Large`, false, eventName !== null && eventName !== void 0 ? eventName : 'PayloadTooLarge', MfsStatusCode.PayloadTooLarge);
    }
}
//# sourceMappingURL=payloadTooLarge.js.map